import { Box, Modal } from "@mui/material";
import "./holiday-cabin-class-modal.scss";
import CloseIcon from "@mui/icons-material/Close";
import CabinClassCard from "../cabin-class-card/cabin-class-card";
import { cabinClassEnum } from "../../../common/enums/cabinClassEnum";

const HolidayCabinClassModal = ({
  contentfulHolidayPage,
  isOpen,
  handleClose,
  isPremiumEconomyEnabled,
}) => {
  const generateCabinClassComponent = (cabinClass, index) => {
    const isPremiumEconomy =
      cabinClass.apiClassName === cabinClassEnum.apiKeys.PremiumEconomy;

    if (!isPremiumEconomyEnabled && isPremiumEconomy) {
      return null;
    }

    const imgUrl = contentfulHolidayPage[cabinClass.imgName]?.fields;
    const cabinClassModal = contentfulHolidayPage?.cabinClassModal;

    return (
      <CabinClassCard
        key={index}
        cabinClass={cabinClass}
        imgUrl={imgUrl}
        cabinClassModal={cabinClassModal}
      />
    );
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      className="cabin-class-modal-wrapper"
      disableEnforceFocus
      disableAutoFocus
    >
      <Box className="cabin-class-modal">
        <div className="cabin-class-modal__header">
          <header>{contentfulHolidayPage?.cabinClassModal?.modalTitle}</header>
          <CloseIcon className="header__close-btn" onClick={handleClose} />
        </div>
        <div className="cabin-class-modal__body">
          <>
            {contentfulHolidayPage.cabinClassModal.flightClass.map(
              (cabinClass, index) =>
                generateCabinClassComponent(cabinClass, index)
            )}
          </>
        </div>
        <div className="cabin-class-modal__footer">
          {contentfulHolidayPage?.cabinClassModal?.footerDescription}
        </div>
      </Box>
    </Modal>
  );
};

export default HolidayCabinClassModal;
